export default "__VITE_ASSET__BTL9M4lb__"